import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleGuida from "../pages/article/guida-completa/page";
import ArticleSicurezza from "../pages/article/sicurezza/page";
import ArticleTutorial from "../pages/article/tutorial/page";
import ArticleScarpe from "../pages/article/scarpe/page";
import ArticleModa from "../pages/article/moda/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/articolo/guida-completa-itaobuy-spreadsheet",
    element: <ArticleGuida />,
  },
  {
    path: "/articolo/itaobuy-spreadsheet-sicurezza",
    element: <ArticleSicurezza />,
  },
  {
    path: "/articolo/come-usare-itaobuy-spreadsheet",
    element: <ArticleTutorial />,
  },
  {
    path: "/articolo/itaobuy-spreadsheet-scarpe-sneakers",
    element: <ArticleScarpe />,
  },
  {
    path: "/articolo/itaobuy-spreadsheet-moda-streetwear",
    element: <ArticleModa />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;